module.exports = __webpack_public_path__ + "img/logo.f03db36c.png";